import {Transaction} from "./transaction"

export interface TransactionsWithCount {
  transactions: Transaction[]
  totalCount: number
}

export const GetEmptyTransactionsWithCount = () => {
  return {totalCount: 0, transactions: []}
}